export default __webpack_public_path__ + "static/public-safety-accomplishment-4-7a728074cdd2566d1c1a83fe016deb5e.webp";